import React, { useEffect } from "react";
import { Box, Button, Flex, Heading, HStack, Icon, SimpleGrid, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { FiCheckCircle, FiEyeOff, FiUnlock, FiLink, FiArrowRight, FiExternalLink } from "react-icons/fi";
import { createVotingHref } from "@lubbezposrednio-frontend/core";
import { InfoPage, InfoBody, InfoSectionTitle } from "../infoShared";

const VALUES = [
  { icon: FiCheckCircle, title: "Weryfikowalność", desc: "Wynik można sprawdzić niezależnie — zaufanie wynika z technologii, nie z deklaracji." },
  { icon: FiEyeOff, title: "Anonimowość", desc: "Tajność głosowania chroni uczestnika, nie odbierając wiarygodności wynikowi." },
  { icon: FiUnlock, title: "Dostępność", desc: "Darmowe narzędzie dla każdej organizacji — bez barier i kosztów wejścia." },
  { icon: FiLink, title: "Niezależność", desc: "Protokół zakotwiczony na blockchainie jest odporny na manipulację i naciski." }
];

export const AboutView: React.FC = () => {
  useEffect(() => {
    document.title = "O platformie lubbezposrednio.pl";
  }, []);

  return (
    <InfoPage
      eyebrow="O nas"
      title="O platformie lubbezposrednio.pl"
      subtitle="Darmowe narzędzie do wiarygodnych, weryfikowalnych głosowań online — by decydować wspólnie i blisko ludzi."
    >
      <InfoBody narrow>
        <InfoSectionTitle>Po co powstała platforma</InfoSectionTitle>
        <Text fontSize={{ base: "16px", md: "17px" }} color="gray.700" lineHeight="1.7" mb="16px">
          Wierzymy, że najlepsze decyzje rodzą się, gdy głos ma każdy. Skuteczność organizacji — stowarzyszeń, spółdzielni,
          wspólnot czy lokalnych grup — rośnie wtedy, gdy w podejmowanie decyzji włącza się możliwie wiele osób.
        </Text>
        <Text fontSize={{ base: "16px", md: "17px" }} color="gray.700" lineHeight="1.7">
          Stworzyliśmy platformę, dzięki której można głosować zarówno w sprawach najważniejszych — wybór władz, zmiany
          statutu, uchwały — jak i w codziennych: nowe logo, udział w wydarzeniu czy jego tytuł. Każdy głos chroni
          kryptografia, a wynik zakotwiczony na blockchainie może zweryfikować każdy.
        </Text>

        <Box mt={{ base: "44px", md: "60px" }}>
          <InfoSectionTitle>W co wierzymy</InfoSectionTitle>
          <SimpleGrid columns={{ base: 1, sm: 2 }} spacing="16px">
            {VALUES.map(v => (
              <HStack key={v.title} align="flex-start" spacing="14px" bg="#F7F5FB" borderRadius="16px" p="20px">
                <Flex w="42px" h="42px" borderRadius="12px" bg="white" align="center" justify="center" flexShrink={0} boxShadow="0 4px 12px rgba(67,0,152,0.07)">
                  <Icon as={v.icon} color="accent" boxSize="20px" />
                </Flex>
                <Box>
                  <Heading fontSize="16px" fontWeight="800" color="primary" mb="4px">
                    {v.title}
                  </Heading>
                  <Text fontSize="14px" color="gray.600" lineHeight="1.55">
                    {v.desc}
                  </Text>
                </Box>
              </HStack>
            ))}
          </SimpleGrid>
        </Box>

        <Box mt={{ base: "44px", md: "60px" }} bg="#F7F5FB" borderRadius="22px" p={{ base: "26px", md: "34px" }}>
          <Text fontSize="12px" fontWeight="800" letterSpacing="0.06em" textTransform="uppercase" color="accent" mb="10px">
            Kto za tym stoi
          </Text>
          <Heading fontSize={{ base: "20px", md: "24px" }} fontWeight="800" color="primary" mb="10px">
            Instytut Demokracji Bezpośredniej
          </Heading>
          <Text fontSize={{ base: "15px", md: "16px" }} color="gray.600" lineHeight="1.65" mb="18px">
            Platforma powstała w ramach działań Instytutu Demokracji Bezpośredniej — inicjatywy budującej kulturę
            wspólnego decydowania na najniższym, najbliższym ludziom szczeblu.
          </Text>
          <Button as="a" href="https://lubbezposrednio.pl" target="_blank" variant="outline" borderColor="primary" color="primary" borderRadius="12px" fontWeight="700" rightIcon={<FiExternalLink />} _hover={{ bg: "rgba(67,0,152,0.05)" }}>
            lubbezposrednio.pl
          </Button>
        </Box>

        <Flex
          mt={{ base: "44px", md: "60px" }}
          direction={{ base: "column", md: "row" }}
          align="center"
          justify="space-between"
          gap="18px"
          bgGradient="linear(135deg, #430098 0%, #6a1fc2 100%)"
          borderRadius="22px"
          px={{ base: "28px", md: "40px" }}
          py={{ base: "30px", md: "34px" }}
          color="white"
          textAlign={{ base: "center", md: "left" }}
        >
          <Box>
            <Heading fontSize={{ base: "21px", md: "24px" }} fontWeight="800">
              Zdecydujcie wspólnie
            </Heading>
            <Text fontSize="15px" color="rgba(255,255,255,0.85)" mt="3px">
              Stwórz swoje pierwsze głosowanie — za darmo.
            </Text>
          </Box>
          <Button as={Link} to={createVotingHref()} bg="white" color="primary" borderRadius="12px" fontWeight="800" px="26px" py="14px" h="auto" flexShrink={0} rightIcon={<FiArrowRight />} _hover={{ bg: "rgba(255,255,255,0.9)" }}>
            Stwórz głosowanie
          </Button>
        </Flex>
      </InfoBody>
    </InfoPage>
  );
};
